<article class="formEditor">
    <span class="formLabel">{{ labelText() }}</span>
    <lib-generic-type-ahead-dropdown
        [source]="items()"
        [selectedItem]="selectedItem()"
        (selectedItemChange)="onSelectedItemChange($event)"
        [placeholder]="placeholderText()"
        [config]="{
            defaultText: placeholderText(),
            itemDisplayKey: 'name'
        }"
        (textChange)="onEntityTextChange($event)"
        [isReadOnly]="isReadOnly()"
    >
    </lib-generic-type-ahead-dropdown>
</article>
